import React from 'react';
import useCountUp from '../hooks/useCountUp';

const AnimatedStat = ({ value, label }) => {
  const numericValue = value.replace(/\D/g, '');
  const suffix = value.replace(/[0-9]/g, '');
  const hasNumber = numericValue.length > 0;
  const { count, ref } = useCountUp(hasNumber ? numericValue : '0', 2000);

  return (
    <div
      ref={ref}
      className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 text-center border border-gray-100 dark:border-gray-700 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    >
      <p className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-blue to-primary-cyan">
        {hasNumber ? `${count}${suffix}` : value}
      </p>
      <p className="text-gray-600 dark:text-gray-300 mt-2 font-medium">{label}</p>
    </div>
  );
};

export default AnimatedStat;
